<template>
    <div class="tab-pane fade show active" id="pricing" role="tabpanel" aria-labelledby="pricing-tab">
        <!-- <table-test></table-test> -->
    </div>
</template>
<script>
// import TableTest from '../generic/table/Index'
export default {
    // components : {'table-test' : TableTest},
    name : 'product-details-table-test'
}
</script>
